export default __webpack_public_path__ + "static/media/Cart.65162fb5.svg";